export const layers: Record<string, number> = {
  default: 0,
  avatarFirstPerson: 9,
  avatarThirdPerson: 10,
  underUI: 14,
  ui: 15,
  overUI: 16,
};
